/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Query_Run } from '../models/Query_Run';
import type { Telemetry_Group } from '../models/Telemetry_Group';
import type { Telemetry_Key } from '../models/Telemetry_Key';
import type { Telemetry_Person } from '../models/Telemetry_Person';
import type { Telemetry_Value } from '../models/Telemetry_Value';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TelemetryService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Run a query
     * @param requestBody The query to run
     * @returns any Successful request
     * @throws ApiError
     */
    public query(
        requestBody: {
            workspaceId: string;
            projectId: string;
            queryId?: string;
            parameters?: {
                /**
                 * Aggregates to compute when running the query
                 */
                calculations?: Array<{
                    key?: string;
                    operator: 'uniq' | 'count' | 'max' | 'min' | 'sum' | 'avg' | 'median' | 'p001' | 'p01' | 'p05' | 'p10' | 'p25' | 'p75' | 'p90' | 'p95' | 'p99' | 'p999' | 'stddev' | 'variance' | 'array_max_size' | 'array_min_size' | 'array_avg_size';
                    alias?: string;
                }>;
                /**
                 * How to group the query run results
                 */
                groupBys?: Array<{
                    type: 'string' | 'number' | 'boolean';
                    value: string;
                }>;
                /**
                 * How to order the results of the query
                 */
                orderBy?: {
                    value: string;
                    order?: 'asc' | 'desc';
                };
                /**
                 * The limit on the number of events / groups returned in the query results
                 */
                limit?: number;
                /**
                 * The filters to apply on the data when running the query
                 */
                filters?: Array<{
                    /**
                     * The filters to apply on the data in this group
                     */
                    filters?: Array<{
                        key: string;
                        operation: 'exists' | 'is_null' | 'starts_with' | 'regex' | 'includes' | 'not_includes' | 'in' | 'not_in' | 'array_size' | 'array_size_gt' | 'array_size_gte' | 'array_size_lt' | 'array_size_lte' | 'array_is_empty' | 'array_not_empty' | 'array_contains' | 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
                        value?: (string | number | boolean);
                        type: 'string' | 'number' | 'boolean' | 'array';
                    }>;
                    /**
                     * How to combine the filters in this group
                     */
                    filterCombination?: 'and' | 'or';
                }>;
                /**
                 * How to combine the filters across groups
                 */
                filterCombination?: 'and' | 'or';
                /**
                 * Expression to search on the data when running the query
                 */
                needle?: {
                    value: (string | number | boolean);
                    isRegex?: boolean;
                    matchCase?: boolean;
                };
            };
            timeframe: {
                /**
                 * Unix start time in milliseconds
                 */
                from: number;
                /**
                 * Unix end time in milliseconds
                 */
                to: number;
            };
            granularity?: number;
            limit?: number;
            view?: 'events' | 'calculations' | 'requests';
            dry?: boolean;
            ignoreSeries?: boolean;
            offset?: string;
            offsetDirection: 'next' | 'prev';
            compare?: boolean;
            chart?: boolean;
        },
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: {
            run: Query_Run;
            calculations?: {
                series: Array<{
                    time: string;
                    data: Array<{
                        aggregates: {
                            _count: number;
                            _interval: number;
                            bin?: any;
                        };
                        /**
                         * Groups in the query results
                         */
                        groups?: Record<string, (string | number | boolean)>;
                    }>;
                }>;
                aggregates: Array<{
                    /**
                     * Groups in the query results
                     */
                    groups?: Record<string, (string | number | boolean)>;
                    /**
                     * Query results
                     */
                    values: Record<string, (string | number | boolean)>;
                }>;
            };
            compare?: {
                series: Array<{
                    time: string;
                    data: Array<{
                        aggregates: {
                            _count: number;
                            _interval: number;
                            bin?: any;
                        };
                        /**
                         * Groups in the query results
                         */
                        groups?: Record<string, (string | number | boolean)>;
                    }>;
                }>;
                aggregates: Array<{
                    /**
                     * Groups in the query results
                     */
                    groups?: Record<string, (string | number | boolean)>;
                    /**
                     * Query results
                     */
                    values: Record<string, (string | number | boolean)>;
                }>;
            };
            events?: {
                events?: Array<{
                    _workspaceId: string;
                    _projectId: string;
                    _timestamp: number;
                    _insertId: string;
                    _distinctId: string;
                    _groupId?: string;
                    _name: string;
                    _now?: number;
                    _prompt: string;
                    _context?: string;
                    _response: string;
                    _judge: string;
                    _critique: string;
                    _outcome: 'pass' | 'fail';
                    _properties: Record<string, any>;
                    _anonymousId?: string;
                    _requestId?: string;
                    _traceId?: string;
                    _spanId?: string;
                    _parentSpanId?: string;
                    _startTimeMs: number;
                    _endTimeMs: number;
                    _service?: string;
                    _path?: string;
                    _method?: string;
                    _logLevel?: string;
                    _durationMs?: number;
                    _statusCode?: number;
                    _traceDurationMs?: number;
                    _error?: string;
                    _message?: string;
                    _spanName?: string;
                    _url?: string;
                    _customerSampleInterval?: number;
                    _platform?: string;
                    _platformModel?: string;
                    _platformVersion?: string;
                    _country?: string;
                    _city?: string;
                    _timezone?: string;
                    _region?: string;
                    _deviceType?: string;
                    _deviceId?: string;
                    _browser?: string;
                    _os?: string;
                    _osVersion?: string;
                    _browserVersion?: string;
                    _stringNames?: Array<string>;
                    _booleanNames?: Array<string>;
                    _numberNames?: Array<string>;
                    _stringValues?: Array<string>;
                    _booleanValues?: Array<boolean>;
                    _numberValues?: Array<number>;
                    _arrayNames?: Array<string>;
                    _arraySizes?: Array<number>;
                }>;
                series?: Array<{
                    time: string;
                    data: Array<{
                        aggregates: {
                            _count: number;
                            _interval: number;
                            bin?: any;
                        };
                        /**
                         * Groups in the query results
                         */
                        groups?: Record<string, (string | number | boolean)>;
                    }>;
                }>;
                fields?: Array<{
                    key: string;
                    type: string;
                }>;
                count?: number;
            };
            requests?: Record<string, Array<{
                _workspaceId: string;
                _projectId: string;
                _timestamp: number;
                _insertId: string;
                _distinctId: string;
                _groupId?: string;
                _name: string;
                _now?: number;
                _prompt: string;
                _context?: string;
                _response: string;
                _judge: string;
                _critique: string;
                _outcome: 'pass' | 'fail';
                _properties: Record<string, any>;
                _anonymousId?: string;
                _requestId?: string;
                _traceId?: string;
                _spanId?: string;
                _parentSpanId?: string;
                _startTimeMs: number;
                _endTimeMs: number;
                _service?: string;
                _path?: string;
                _method?: string;
                _logLevel?: string;
                _durationMs?: number;
                _statusCode?: number;
                _traceDurationMs?: number;
                _error?: string;
                _message?: string;
                _spanName?: string;
                _url?: string;
                _customerSampleInterval?: number;
                _platform?: string;
                _platformModel?: string;
                _platformVersion?: string;
                _country?: string;
                _city?: string;
                _timezone?: string;
                _region?: string;
                _deviceType?: string;
                _deviceId?: string;
                _browser?: string;
                _os?: string;
                _osVersion?: string;
                _browserVersion?: string;
                _stringNames?: Array<string>;
                _booleanNames?: Array<string>;
                _numberNames?: Array<string>;
                _stringValues?: Array<string>;
                _booleanValues?: Array<boolean>;
                _numberValues?: Array<number>;
                _arrayNames?: Array<string>;
                _arraySizes?: Array<number>;
            }>>;
            statistics?: {
                /**
                 * Query excecution duration in seconds
                 */
                elapsed: number;
                /**
                 * Number of rows read from the table
                 */
                rows_read: number;
                /**
                 * Number of uncompressed bytes read from the table
                 */
                bytes_read: number;
            };
        };
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/telemetry/query',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * List people
     * @param requestBody The filters to apply
     * @returns any Successful request
     * @throws ApiError
     */
    public peopleList(
        requestBody: {
            workspaceId: string;
            projectId: string;
            traits?: {
                /**
                 * The filters to apply on the data when running the query
                 */
                filters?: Array<{
                    /**
                     * The filters to apply on the data in this group
                     */
                    filters?: Array<{
                        key: string;
                        operation: 'exists' | 'is_null' | 'starts_with' | 'regex' | 'includes' | 'not_includes' | 'in' | 'not_in' | 'array_size' | 'array_size_gt' | 'array_size_gte' | 'array_size_lt' | 'array_size_lte' | 'array_is_empty' | 'array_not_empty' | 'array_contains' | 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
                        value?: (string | number | boolean);
                        type: 'string' | 'number' | 'boolean' | 'array';
                    }>;
                    /**
                     * How to combine the filters in this group
                     */
                    filterCombination?: 'and' | 'or';
                }>;
                /**
                 * Expression to search on the data when running the query
                 */
                needle?: {
                    value: (string | number | boolean);
                    isRegex?: boolean;
                    matchCase?: boolean;
                };
                /**
                 * How to combine the filters across groups
                 */
                filterCombination?: 'and' | 'or';
            };
            groups?: Array<{
                key: '$zirp.groupId';
                operation: 'exists' | 'is_null' | 'starts_with' | 'regex' | 'includes' | 'not_includes' | 'in' | 'not_in' | 'array_size' | 'array_size_gt' | 'array_size_gte' | 'array_size_lt' | 'array_size_lte' | 'array_is_empty' | 'array_not_empty' | 'array_contains' | 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
                value?: string;
                type: 'string';
            }>;
            behaviours?: Array<({
                type: 'single';
                event: string;
                count?: number;
                operation?: 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
                properties?: Array<{
                    key: string;
                    operation: 'exists' | 'is_null' | 'starts_with' | 'regex' | 'includes' | 'not_includes' | 'in' | 'not_in' | 'array_size' | 'array_size_gt' | 'array_size_gte' | 'array_size_lt' | 'array_size_lte' | 'array_is_empty' | 'array_not_empty' | 'array_contains' | 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
                    value?: (string | number | boolean);
                    type: 'string' | 'number' | 'boolean' | 'array';
                }>;
                timeframe: {
                    /**
                     * Unix start time in milliseconds
                     */
                    from: number;
                    /**
                     * Unix end time in milliseconds
                     */
                    to: number;
                };
            } | {
                type: 'sequence';
                events: Array<string>;
                count?: number;
                operation?: 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
                within?: {
                    value: number;
                    unit: 'second' | 'minute' | 'hour' | 'day' | 'week' | 'month' | 'year';
                };
                timeframe: {
                    /**
                     * Unix start time in milliseconds
                     */
                    from: number;
                    /**
                     * Unix end time in milliseconds
                     */
                    to: number;
                };
            })>;
            lifecycles?: Array<({
                type: 'first_time';
                event: string;
                timeframe: {
                    /**
                     * Unix start time in milliseconds
                     */
                    from: number;
                    /**
                     * Unix end time in milliseconds
                     */
                    to: number;
                };
            } | {
                type: 'frequent';
                event: string;
                timeframe: {
                    /**
                     * Unix start time in milliseconds
                     */
                    from: number;
                    /**
                     * Unix end time in milliseconds
                     */
                    to: number;
                };
                /**
                 * How many times did the event occur within the selected timeframe?
                 */
                occurences?: {
                    count?: number;
                    operation?: 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
                };
                /**
                 * What's the maximum gap between consecutive events?
                 */
                within: {
                    value: number;
                    unit: 'second' | 'minute' | 'hour' | 'day' | 'week' | 'month' | 'year';
                };
            } | {
                type: 'churned';
                event: string;
                timeframe: {
                    /**
                     * Unix start time in milliseconds
                     */
                    from: number;
                    /**
                     * Unix end time in milliseconds
                     */
                    to: number;
                };
                /**
                 * How many times did the event occur within the selected timeframe?
                 */
                occurences?: {
                    count?: number;
                    operation?: 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
                };
                /**
                 * How long has it been since the last event, at minimum?
                 */
                inactivity: {
                    value: number;
                    unit: 'second' | 'minute' | 'hour' | 'day' | 'week' | 'month' | 'year';
                };
            } | {
                type: 'resurrected';
                event: string;
                timeframe: {
                    /**
                     * Unix start time in milliseconds
                     */
                    from: number;
                    /**
                     * Unix end time in milliseconds
                     */
                    to: number;
                };
                /**
                 * How many times did the event occur within the selected timeframe, after the inactivity period?
                 */
                occurences?: {
                    count?: number;
                    operation?: 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
                };
                /**
                 * How many times did the event occur within the selected timeframe, before the inactivity period?
                 */
                history?: {
                    count?: number;
                    operation?: 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
                };
                /**
                 * How long was the account innactive at minimum?
                 */
                inactivity: {
                    value: number;
                    unit: 'second' | 'minute' | 'hour' | 'day' | 'week' | 'month' | 'year';
                };
            })>;
            limit?: number;
            offset?: string;
            offsetDirection?: 'next' | 'prev';
        },
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Array<Telemetry_Person>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/telemetry/people',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Get a person
     * @param workspaceId
     * @param projectId
     * @param id
     * @returns any Successful request
     * @throws ApiError
     */
    public personGet(
        workspaceId: string,
        projectId: string,
        id: string,
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Telemetry_Person;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/telemetry/people/{workspaceId}/{projectId}/{id}',
            path: {
                'workspaceId': workspaceId,
                'projectId': projectId,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * List groups
     * @param requestBody The filters to apply
     * @returns any Successful request
     * @throws ApiError
     */
    public groupsList(
        requestBody: Telemetry_Group,
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Array<{
            workspaceId: string;
            projectId: string;
            traits: Record<string, any>;
            $zirp: {
                id: string;
                name?: string;
                domain?: string;
                firstSeen: number | null;
                lastSeen: number | null;
                created: number | null;
                updated: number | null;
            };
        }>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/telemetry/groups',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Get a group
     * @param workspaceId
     * @param projectId
     * @param id
     * @returns any Successful request
     * @throws ApiError
     */
    public groupGet(
        workspaceId: string,
        projectId: string,
        id: string,
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: {
            workspaceId: string;
            projectId: string;
            traits: Record<string, any>;
            $zirp: {
                id: string;
                name?: string;
                domain?: string;
                firstSeen: number | null;
                lastSeen: number | null;
                created: number | null;
                updated: number | null;
            };
        };
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/telemetry/groups/{workspaceId}/{projectId}/{id}',
            path: {
                'workspaceId': workspaceId,
                'projectId': projectId,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * List available keys
     * @param requestBody The filters to apply
     * @returns any Successful request
     * @throws ApiError
     */
    public keysList(
        requestBody: {
            workspaceId: string;
            projectId: string;
            timeframe: {
                /**
                 * Unix start time in milliseconds
                 */
                from: number;
                /**
                 * Unix end time in milliseconds
                 */
                to: number;
            };
            stream?: {
                /**
                 * The filters to apply on the data when running the query
                 */
                filters?: Array<{
                    /**
                     * The filters to apply on the data in this group
                     */
                    filters?: Array<{
                        key: string;
                        operation: 'exists' | 'is_null' | 'starts_with' | 'regex' | 'includes' | 'not_includes' | 'in' | 'not_in' | 'array_size' | 'array_size_gt' | 'array_size_gte' | 'array_size_lt' | 'array_size_lte' | 'array_is_empty' | 'array_not_empty' | 'array_contains' | 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
                        value?: (string | number | boolean);
                        type: 'string' | 'number' | 'boolean' | 'array';
                    }>;
                    /**
                     * How to combine the filters in this group
                     */
                    filterCombination?: 'and' | 'or';
                }>;
                /**
                 * Expression to search on the data when running the query
                 */
                needle?: {
                    value: (string | number | boolean);
                    isRegex?: boolean;
                    matchCase?: boolean;
                };
                /**
                 * How to combine the filters across groups
                 */
                filterCombination?: 'and' | 'or';
            };
            limit?: number;
            keyNeedle?: {
                value: (string | number | boolean);
                isRegex?: boolean;
                matchCase?: boolean;
            };
            resource: 'telemetry' | 'people' | 'groups';
        },
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Array<Telemetry_Key>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/telemetry/keys',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * List available values for a key
     * @param requestBody The filters to apply
     * @returns any Successful request
     * @throws ApiError
     */
    public valuesList(
        requestBody: {
            workspaceId: string;
            projectId: string;
            key?: string;
            type?: 'string' | 'number' | 'boolean';
            timeframe: {
                /**
                 * Unix start time in milliseconds
                 */
                from: number;
                /**
                 * Unix end time in milliseconds
                 */
                to: number;
            };
            stream?: {
                /**
                 * The filters to apply on the data when running the query
                 */
                filters?: Array<{
                    /**
                     * The filters to apply on the data in this group
                     */
                    filters?: Array<{
                        key: string;
                        operation: 'exists' | 'is_null' | 'starts_with' | 'regex' | 'includes' | 'not_includes' | 'in' | 'not_in' | 'array_size' | 'array_size_gt' | 'array_size_gte' | 'array_size_lt' | 'array_size_lte' | 'array_is_empty' | 'array_not_empty' | 'array_contains' | 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
                        value?: (string | number | boolean);
                        type: 'string' | 'number' | 'boolean' | 'array';
                    }>;
                    /**
                     * How to combine the filters in this group
                     */
                    filterCombination?: 'and' | 'or';
                }>;
                /**
                 * Expression to search on the data when running the query
                 */
                needle?: {
                    value: (string | number | boolean);
                    isRegex?: boolean;
                    matchCase?: boolean;
                };
                /**
                 * How to combine the filters across groups
                 */
                filterCombination?: 'and' | 'or';
            };
            limit?: number;
            valueNeedle?: {
                value: (string | number | boolean);
                isRegex?: boolean;
                matchCase?: boolean;
            };
            resource: 'telemetry' | 'people' | 'groups';
        },
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Array<Telemetry_Value>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/telemetry/values',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
}
